import React from 'react'
import { Link } from 'react-router-dom'
import CustomerAdd from './UserAdd'
import BookingHistory from '../Users/BookingHistoryList'

class UserAddTab extends React.Component {
  state = {}

  componentDidMount() {
    if (
      this.props.match.params.customer_id !== undefined &&
      this.props.match.params.customer_id !== null &&
      this.props.match.params.customer_id !== 0 &&
      this.props.match.params.customer_id !== ''
    ) {
      this.setState({ customer_id: this.props.match?.params?.customer_id })
    }
  }
  handleLanguage = (language_id) => {
    this.setState({ language_id: language_id })
  }
  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>{this.props.match.params.customer_id ? 'Edit' : 'Add'} User</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/customers">Customers</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      {this.props.match.params.customer_id ? 'Edit' : 'Add'} User
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="tab-content tabs">
                      <div
                        className="tab-pane  active"
                        id={'add_user_' + this.state.language_id}
                        role="tabpanel"
                        aria-labelledby=""
                      >
                        {this.state.customer_id !== undefined &&
                        this.state.customer_id !== null &&
                        this.state.customer_id !== 0 &&
                        this.state.customer_id !== '' ? (
                          <CustomerAdd
                            language_id={this.state.language_id}
                            goBack={this.props.history.goBack}
                            customer_id={this.state.customer_id}
                          />
                        ) : (
                          <CustomerAdd
                            language_id={this.state.language_id}
                            goBack={this.props.history.goBack}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                {/* <div className="card card-border-default">
                  <div className="card-block"> */}
                <div className="tab-content tabs">
                  <div
                    className="tab-pane  active"
                    id={'add_user_' + this.state.language_id}
                    role="tabpanel"
                    aria-labelledby=""
                  >
                    {this.props.match.params.customer_id !== undefined &&
                    this.props.match.params.customer_id !== null &&
                    this.props.match.params.customer_id !== 0 &&
                    this.props.match.params.customer_id !== '' ? (
                      <BookingHistory
                        language_id={this.state.language_id}
                        goBack={this.props.history.goBack}
                        customer_id={this.props.match.params.customer_id}
                      />
                    ) : (
                      <BookingHistory
                        language_id={this.state.language_id}
                        goBack={this.props.history.goBack}
                      />
                    )}
                  </div>
                </div>
                {/* </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default UserAddTab
